import { Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Companies from "./pages/Companies";
import CompanyDetail from "./pages/CompanyDetail";
import Persons from "./pages/Persons";
import PersonDetail from "./pages/PersonDetail";
import Tags from "./pages/Tags";
import ImportPage from "./pages/Import";
import ProjectDetail from "./pages/ProjectDetail";
import Inbox from "./pages/Inbox";
import EmailDetail from "./pages/EmailDetail";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import TasksPage from "./pages/Tasks";
import Settings from "./pages/Settings";
import Calendar from "./pages/Calendar";
import Consents from "./pages/Consents";
import MonitorCheckup from "./pages/MonitorCheckup";
import ClientValue from "./pages/ClientValue";
import Invoices from "./pages/Invoices";
import EmailTemplates from "./pages/EmailTemplates";
import Contatti from "./pages/Contatti";
import Funnel from "./pages/Funnel";
import Approvals from "./pages/Approvals";
import Projects from "./pages/Projects";
import Campaigns from "./pages/Campaigns";
import KanbanRiunioni from "./pages/KanbanRiunioni";
import SentEmails from "./pages/SentEmails";
import F24 from "./pages/F24";
import Contabilita from "./pages/Contabilita";
import ScadenzarioFiscale from "./pages/ScadenzarioFiscale";
import Workspace from "./pages/Workspace";
import Webmail from "./pages/Webmail";
import ColpoDocchio from "./pages/ColpoDocchio";
import ComposerWindow from "./pages/ComposerWindow";
import WhatsAppChat from "./pages/WhatsAppChat";
import PublicBooking from "./pages/PublicBooking";
import PublicReview from "./pages/PublicReview";
import PublicConfirm from "./pages/PublicConfirm";
import Cruscotti from "./pages/Cruscotti";
import CruscottoPubblico from "./pages/CruscottoPubblico";
import Login from "./pages/Login";
import { TOKEN_KEY } from "./api";
import { OptinSubscribe, OptinConfirm, OptinUnsubscribe, OptinPreferences } from "./pages/Optin";
import NotificationBell from "./components/NotificationBell";
import AssistantChat from "./components/AssistantChat";
import { Mascot, MASC_ROBOT } from "./components/Mascots";
import { useEffect, useState } from "react";
import api from "./api";
import { updateBadge } from "./push";
import PushBanner from "./components/PushBanner";
import NetBanner from "./components/NetBanner";
import BackToTop from "./components/BackToTop";
import TableExportOverlay from "./components/TableExportOverlay";
import {
  LayoutDashboard, Inbox as InboxIcon, CalendarDays, ClipboardList, Landmark,
  Calculator, FolderOpen, CheckSquare, Users, Receipt, Target, Filter,
  LayoutTemplate, Megaphone, Send, Settings as SettingsIcon, LogOut, Briefcase,
  Mail, MessageCircle,
  Activity, SquareKanban, Table2, Gauge,
} from "lucide-react";

const NAV_GROUPS = [
  {
    label: null,
    items: [
      { to: "/", end: true, tid: "dashboard", label: "Dashboard", Icon: LayoutDashboard, color: "#38bdf8" },
      { to: "/da-gestire", tid: "da-gestire", label: "Da gestire", Icon: InboxIcon, badge: "count", color: "#f59e0b" },
      { to: "/posta", tid: "posta", label: "Posta", Icon: Mail, color: "#60a5fa" },
      { to: "/whatsapp", tid: "whatsapp", label: "WhatsApp", Icon: MessageCircle, color: "#25d366" },
      { to: "/calendario", tid: "calendario", label: "Calendario", Icon: CalendarDays, badge: "pending", color: "#f472b6" },
      { to: "/incarichi", tid: "incarichi", label: "Incarichi", Icon: ClipboardList, color: "#a78bfa" },
      { to: "/colpo-docchio", tid: "colpo-docchio", label: "Colpo d'occhio", Icon: Table2, color: "#facc15" },
      { to: "/scadenze-f24", tid: "f24", label: "Scadenze F24", Icon: Landmark, color: "#ef4444" },
      { to: "/scadenzario-fiscale", tid: "scadenzario-fiscale", label: "Scadenzario fiscale", Icon: CalendarDays, color: "#fb7185" },
      { to: "/contabilita", tid: "contabilita", label: "Situazione registrazioni", Icon: Calculator, color: "#34d399" },
      { to: "/progetti", end: true, tid: "progetti", label: "Progetti", Icon: FolderOpen, color: "#fbbf24" },
      { to: "/da-approvare", tid: "approvazioni", label: "Da approvare", Icon: CheckSquare, badge: "approvals", color: "#fb923c" },
      { to: "/kanban-riunioni", tid: "kanban-riunioni", label: "Kanban riunioni", Icon: SquareKanban, color: "#2dd4bf" },
    ],
  },
  {
    label: "Clienti",
    items: [
      { to: "/area-di-lavoro", tid: "area-di-lavoro", label: "Area di lavoro", Icon: Briefcase, color: "#22d3ee" },
      { to: "/contatti", tid: "contatti", label: "Contatti", Icon: Users, color: "#4ade80" },
      { to: "/fatture", tid: "fatture", label: "Margini clienti", Icon: Receipt, color: "#eab308" },
      { to: "/cruscotti", tid: "cruscotti", label: "Cruscotti", Icon: Gauge, color: "#38bdf8" },
    ],
  },
  {
    label: "Marketing",
    items: [
      { to: "/lead", tid: "lead", label: "Lead", Icon: Target, color: "#f87171" },
      { to: "/funnel", tid: "funnel", label: "Funnel", Icon: Filter, color: "#c084fc" },
      { to: "/monitor-checkup", tid: "monitor-checkup", label: "Monitor Check-up", Icon: Activity, color: "#34d399" },
      { to: "/template-email", tid: "template-email", label: "Template email", Icon: LayoutTemplate, color: "#93c5fd" },
      { to: "/invio-massivo", tid: "invio-massivo", label: "Invio massivo", Icon: Megaphone, color: "#fb7185" },
      { to: "/inviate", tid: "inviate", label: "Inviate", Icon: Send, color: "#5eead4" },
    ],
  },
];

function Sidebar() {
  const [count, setCount] = useState(0);
  const [pending, setPending] = useState(0);
  const [approvals, setApprovals] = useState(0);
  const [moreOpen, setMoreOpen] = useState(false);
  useEffect(() => {
    const load = () => {
      api.get("/emails/count").then((r) => setCount(r.data.da_gestire)).catch(() => {});
      api.get("/stats/dashboard").then((r) => setPending(r.data.pending_appts || 0)).catch(() => {});
      api.get("/approvals/count").then((r) => setApprovals(r.data.pending || 0)).catch(() => {});
    };
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => { updateBadge(count + approvals); }, [count, approvals]);
  const logout = () => { localStorage.removeItem("crm_token"); window.location.href = "/login"; };
  const b = (n) => (n > 0 ? <span className="nav-badge">{n}</span> : null);
  const closeMore = () => setMoreOpen(false);
  const badges = { count, pending, approvals };
  return (
    <>
      <aside className="sidebar">
        <div className="brand"><Mascot className="brand-logo" svg={MASC_ROBOT} />CRM Silvia Casali</div>
        <nav>
          {NAV_GROUPS.map((g, gi) => (
            <div key={gi} className="nav-group">
              {g.label && <div className="nav-group-label">{g.label}</div>}
              {g.items.map((it) => it.href ? (
                <a key={it.href} href={it.href} target="_blank" rel="noreferrer" data-testid={`nav-${it.tid}`} title="Si apre in una nuova scheda (solo dal computer dove gira l'app)">
                  <it.Icon className="nav-icon" size={17} strokeWidth={2.2} style={{ color: it.color }} />
                  {it.label} <span style={{ opacity: 0.5, fontSize: 11 }}>↗</span>
                </a>
              ) : (
                <NavLink key={it.to} to={it.to} end={it.end} data-testid={`nav-${it.tid}`}>
                  <it.Icon className="nav-icon" size={17} strokeWidth={2.2} style={{ color: it.color }} />
                  {it.label} {it.badge ? b(badges[it.badge]) : null}
                </NavLink>
              ))}
            </div>
          ))}
          <div className="nav-sep" />
          <NavLink to="/impostazioni" data-testid="nav-impostazioni"><SettingsIcon className="nav-icon" size={17} strokeWidth={2} />Impostazioni</NavLink>
          <button className="nav-logout" data-testid="logout-btn" onClick={logout}><LogOut className="nav-icon" size={17} strokeWidth={2} />Esci</button>
        </nav>
      </aside>

      <button className={`mm-fab${moreOpen ? " open" : ""}`} data-testid="mobile-menu-fab"
              onClick={() => setMoreOpen((v) => !v)} aria-label="Menu">
        {moreOpen ? <span className="mm-fab-x">✕</span> : <img src="/wand-magic.png" alt="Menu" className="mm-fab-wand-img" />}
        {!moreOpen && (count + approvals) > 0 && <span className="nav-badge mm-fab-badge">{count + approvals}</span>}
      </button>

      {moreOpen && (
        <div className="mm-overlay" data-testid="mobile-menu-overlay" onClick={closeMore}>
          <div className="mm-grid" onClick={(e) => e.stopPropagation()}>
            {NAV_GROUPS.flatMap((g) => g.items).map((it, i) => it.href ? (
              <a key={it.href} href={it.href} target="_blank" rel="noreferrer" onClick={closeMore} className="mm-item"
                 style={{ "--c": it.color, "--d": `${i * 24}ms` }} data-testid={`mmore-${it.tid}`}>
                <span className="mm-orb"><it.Icon size={24} strokeWidth={2.1} /></span>
                <span className="mm-lbl">{it.label}</span>
              </a>
            ) : (
              <NavLink key={it.to} to={it.to} end={it.end} onClick={closeMore} className="mm-item"
                       style={{ "--c": it.color, "--d": `${i * 24}ms` }} data-testid={`mmore-${it.tid}`}>
                <span className="mm-orb">
                  <it.Icon size={24} strokeWidth={2.1} />
                  {it.badge && badges[it.badge] > 0 && <span className="mm-badge">{badges[it.badge]}</span>}
                </span>
                <span className="mm-lbl">{it.label}</span>
              </NavLink>
            ))}
            <NavLink to="/impostazioni" onClick={closeMore} className="mm-item"
                     style={{ "--c": "#94a3b8", "--d": "420ms" }} data-testid="mmore-impostazioni">
              <span className="mm-orb"><SettingsIcon size={24} strokeWidth={2} /></span>
              <span className="mm-lbl">Impostazioni</span>
            </NavLink>
            <button className="mm-item" onClick={logout} style={{ "--c": "#fb7185", "--d": "444ms" }} data-testid="mmore-logout">
              <span className="mm-orb"><LogOut size={24} strokeWidth={2} /></span>
              <span className="mm-lbl">Esci</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/prenota" element={<PublicBooking />} />
      <Route path="/recensione" element={<PublicReview />} />
      <Route path="/conferma" element={<PublicConfirm />} />
      <Route path="/cruscotto/:codice" element={<CruscottoPubblico />} />
      <Route path="/iscriviti" element={<OptinSubscribe />} />
      <Route path="/c/:token" element={<OptinConfirm />} />
      <Route path="/u/:token" element={<OptinUnsubscribe />} />
      <Route path="/p/:token" element={<OptinPreferences />} />
      <Route path="/login" element={<Login />} />
      <Route path="/scrivi" element={<ComposerWindow />} />
      <Route path="/*" element={<AppShell />} />
    </Routes>
  );
}

const PINK_ROUTES = ["/lead", "/funnel", "/template-email", "/invio-massivo", "/da-approvare"];

function AppShell() {
  const { pathname } = useLocation();
  const pink = PINK_ROUTES.some((p) => pathname.startsWith(p));
  const duo = pathname === "/";
  const [role, setRole] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return;
    api.get("/auth/me").then((r) => setRole(r.data.role || "admin")).catch(() => setRole("admin"));
  }, []);
  if (!localStorage.getItem(TOKEN_KEY)) return <Navigate to="/login" replace />;
  if (role === null) return null;
  if (role === "collaboratore") {
    return (
      <div className="layout">
        <aside className="sidebar">
          <div className="brand"><Mascot className="brand-logo" svg={MASC_ROBOT} />CRM Silvia Casali</div>
          <nav>
            <NavLink to="/contabilita" data-testid="nav-contabilita"><Calculator className="nav-icon" size={17} strokeWidth={2} />Situazione registrazioni</NavLink>
            <button className="nav-logout" data-testid="logout-btn" onClick={() => { localStorage.removeItem(TOKEN_KEY); window.location.href = "/login"; }}><LogOut className="nav-icon" size={17} strokeWidth={2} />Esci</button>
          </nav>
        </aside>
        <main className="content">
          <NetBanner />
          <Routes>
            <Route path="/contabilita" element={<Contabilita />} />
            <Route path="*" element={<Navigate to="/contabilita" replace />} />
          </Routes>
          <BackToTop />
          <TableExportOverlay />
        </main>
      </div>
    );
  }
  return (
    <div className={"layout" + (pink ? " theme-pink" : "") + (duo ? " theme-duo" : "")}>
      <Sidebar />
      <main className="content">
        <div className="topbar-actions"><NotificationBell /></div>
        <AssistantChat />
        <NetBanner />
        <PushBanner />
        <BackToTop />
        <TableExportOverlay />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/da-gestire" element={<Inbox />} />
          <Route path="/posta" element={<Webmail />} />
          <Route path="/whatsapp" element={<WhatsAppChat />} />
          <Route path="/email/:id" element={<EmailDetail />} />
          <Route path="/calendario" element={<Calendar />} />
          <Route path="/incarichi" element={<TasksPage />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/area-di-lavoro" element={<Workspace />} />
          <Route path="/lead" element={<Leads />} />
          <Route path="/lead/:id" element={<LeadDetail />} />
          <Route path="/funnel" element={<Funnel />} />
          <Route path="/da-approvare" element={<Approvals />} />
          <Route path="/progetti" element={<Projects />} />
          <Route path="/template-email" element={<EmailTemplates />} />
          <Route path="/invio-massivo" element={<Campaigns />} />
          <Route path="/kanban-riunioni" element={<KanbanRiunioni />} />
          <Route path="/inviate" element={<SentEmails />} />
          <Route path="/fatture" element={<Invoices />} />
          <Route path="/cruscotti" element={<Cruscotti />} />          <Route path="/colpo-docchio" element={<ColpoDocchio />} />
          <Route path="/scadenze-f24" element={<F24 />} />
          <Route path="/scadenzario-fiscale" element={<ScadenzarioFiscale />} />
          <Route path="/contabilita" element={<Contabilita />} />
          <Route path="/impostazioni" element={<Settings />} />
          <Route path="/aziende" element={<Companies />} />
          <Route path="/aziende/:id" element={<CompanyDetail />} />
          <Route path="/persone" element={<Persons />} />
          <Route path="/persone/:id" element={<PersonDetail />} />
          <Route path="/valore-clienti" element={<ClientValue />} />
          <Route path="/consensi" element={<Consents />} />
          <Route path="/monitor-checkup" element={<MonitorCheckup />} />
          <Route path="/etichette" element={<Tags />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/progetti/:id" element={<ProjectDetail />} />
        </Routes>
      </main>
    </div>
  );
}
